/**
 *
 * @author arman
 * @since 7/25/17
 *
 */
import moment from 'moment';

export default {
  toAppDate: (date) => (
    moment(date).format('h:mm a, MM/DD/YYYY')
  ),
  toAppTime: (date) => (
    moment(date).format('h:mm a')
  ),
  toDate: (date) => (
      moment(date).format('MM/DD/YYYY')
  ),
  momentDateTime: (date, time) => {
    let momentTime = moment(time);
    let momentDate = moment(date);
    return moment({
      year: momentDate.year(),
      month: momentDate.month(),
      day: momentDate.date(),
      hour: momentTime.hours(),
      minute: momentTime.minutes()
    });
  },
  capitalizeFirstLetter: (string) => (
    string.charAt(0).toUpperCase() + string.slice(1)
  ),
  toMomentCalendarDate: (date) => (
    moment(date).calendar()
  ),
  isSameDay: (day1, day2) => (
    moment(day1).isSame(day2, 'day')
  )
}


// WEBPACK FOOTER //
// ./src/utility/utils.js